export class StudentCardTypeComponent {
	private id: string;
	private description: string; // La descripcion del campo
	private villeId: number;
	private active: boolean;
	private totalLines: number = 0;
	private mandatoryLines: number = 0;
	
	constructor( id: string, description: string, villeId: number, active: boolean, totalLines: number, mandatoryLines: number ) {
		this.id = id;
		this.description = description;
		this.villeId = villeId;
		this.active = active;
		this.totalLines = totalLines;
		this.mandatoryLines = mandatoryLines;
	}

	public setId (id: string) { this.id = id; }
	public getId () { return this.id; }

	public setDescription (description: string) { this.description = description; }
	public getDescription () { return this.description; }
	
	public setVilleId (villeId: number) { this.villeId = villeId; }
	public getVilleId () { return this.villeId; }
	
	public setActive (active: boolean) { this.active = active; }
	public getActive () { return this.active; }
	
	public setTotalLines (totalLines: number) { this.totalLines = totalLines; }
	public getTotalLines () { return this.totalLines; }
	
	public setMandatoryLines (mandatoryLines: number) { this.mandatoryLines = mandatoryLines; }
	public getMandatoryLines () { return this.mandatoryLines; }
}



// WEBPACK FOOTER //
// ./src/app/DTOs/StudentCardType.component.ts